import React, { useState, useEffect, useContext } from "react";
import _ from "lodash";
import { useIntl, FormattedMessage } from "react-intl";
import { NotificationsContext } from "../../Notifications";
// Services
import AuthenticationService from "../../../services/AuthenticationService";
import apiRequest from "../../../services/apiRequest";
import ErrorBoundary from "../../ErrorBoundary";

// Components
import AddGroupDialog from "./AddGroupDialog";
import AddUserToGroupDialog from "./AddUserToGroupDialog";
import GroupsTable from "./GroupsTable";

// UI
import { UserPlusIcon } from "@heroicons/react/24/solid";
import { PageHeading } from "../../Container";
import Button from "../../Button";
import CountryContext from "../../../CountryContext";
import Placeholder from "../../Placeholder";

function Groups() {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const [selectedGroup, setSelectedGroup] = useState();
  const [groups, setGroups] = useState();
  const [showNewGroupDialog, setShowNewGroupDialog] = useState(false);
  const [showAddUserToGroupDialog, setShowAddUserToGroupDialog] =
    useState(false);
  const scopes = AuthenticationService.getUserScopes();
  const userData = AuthenticationService.getUserData();

  useEffect(() => {
    const fetchGroups = () => {
      apiRequest
        .get(`/groups`)
        .then((groups) => {
          setGroups(groups);
        })
        .catch(() => {
          setGroups([]);
          push({
            title: intl.formatMessage({ id: "server_error" }),
            type: "error",
          });
        });
    };
    fetchGroups();
    // eslint-disable-next-line
  }, [showNewGroupDialog]);

  const toggleNewGroupDialog = () => setShowNewGroupDialog(!showNewGroupDialog);
  const toggleAddUserToGroupDialog = () =>
    setShowAddUserToGroupDialog(!showAddUserToGroupDialog);
  const canCreateGroup = scopes.indexOf("user:create") >= 0;

  return (
    <>
      <PageHeading
        title="Gruppi"
        contentActions={
          canCreateGroup ? (
            <Button
              variant="contained"
              color="primary"
              onClick={toggleNewGroupDialog}
            >
              <UserPlusIcon
                className="-ml-0.5 mr-2 h-4 w-4"
                aria-hidden="true"
              />
              <FormattedMessage id="add" />
            </Button>
          ) : null
        }
      />
      <ErrorBoundary from="groups-table">
        {groups ? (
          <GroupsTable
            groups={groups}
            setGroups={setGroups}
            toggleAddUserToGroupDialog={toggleAddUserToGroupDialog}
            push={push}
            setSelectedGroup={setSelectedGroup}
          />
        ) : (
          <div className="flex flex-col w-full my-10 gap-y-3">
            <Placeholder
              height="h-16"
              classNames={`rounded-lg bg-${userData.business}-400`}
            />
            <Placeholder height="h-64" classNames="rounded-lg" />
          </div>
        )}
      </ErrorBoundary>
      {canCreateGroup ? (
        <ErrorBoundary from="groups-add-dialog">
          <AddGroupDialog
            open={showNewGroupDialog}
            toggleOpen={toggleNewGroupDialog}
            groups={groups}
            setGroups={setGroups}
          />
        </ErrorBoundary>
      ) : null}
      <ErrorBoundary from="groups-add-user-to-group-dialog">
        <AddUserToGroupDialog
          open={showAddUserToGroupDialog}
          toggleOpen={toggleAddUserToGroupDialog}
          selectedGroup={selectedGroup}
        />
      </ErrorBoundary>
    </>
  );
}

export default Groups;
